import { LoadingSpinner, LoadingSpinnerSize } from '@steelbuy/ui-primitive';

import './AddressLoadingIndicator.scss';

export const AddressLoadingIndicator = () => (
    <div className="address-loading-indicator">
        <LoadingSpinner symbolSize={LoadingSpinnerSize.SMALL} fullHeight={false} />
    </div>
);
